import React from 'react';

const MarketPanelPutCallRatio = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Put Call Ratio</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="put-call-ratio">
            <thead>
              <tr>
                <th>Index</th>
                <th>PCR</th>
                <th>Change</th>
                <th>Previous PCR</th>
                <th>PCR Trend</th>
                <th>Call OI</th>
                <th>Put OI</th>
                <th>Total OI</th>
                <th>Call Volume</th>
                <th>Put Volume</th>
                <th>Total Volume</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.index || '-'}</td>
                    <td>{item.pcr || '-'}</td>
                    <td>{item.change || '-'}</td>
                    <td>{item.previous_pcr || '-'}</td>
                    <td>{item.pcr_trend || '-'}</td>
                    <td>{item.call_oi || '-'}</td>
                    <td>{item.put_oi || '-'}</td>
                    <td>{item.total_oi || '-'}</td>
                    <td>{item.call_volume || '-'}</td>
                    <td>{item.put_volume || '-'}</td>
                    <td>{item.total_volume || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelPutCallRatio; 